<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5e_Gusto-tradizione_Gerace_tessitrice.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Gusto e tradizioni</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Gusto e tradizioni</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Terra fertile e ricca d’acqua, la Calabria presenta una straordinaria varietà di prodotti agroalimentari. 
            In ciascun borgo o paese che si incontra vi sono piatti legati alla storia delle comunità che qui si sono insediate, 
            incontrate e integrate nel corso dei secoli, a partire dai sentieri della transumanza, viatico di scambi continui tra montagna e pianura, 
            tradizioni alimentari e lingue. Una varietà che vede primeggiare ortaggi, frutta, cereali, legumi, olio extra vergine di oliva, 
            formaggi caprini e pecorini, pesce azzurro, alla base della vera dieta mediterranea che qui è di casa da sempre come hanno dimostrato gli studi condotti 
            da Ancel Keys a Nicotera nel 1957, sul rapporto tra benessere, alimentazione e stile di vita, e quelli più recenti di Valter Longo che ha individuato a 
            Molochio, paese di ultracentenari, i segreti della longevità.
            <br>
            <br>
            Un capitolo a parte meritano i dolci che sono un compendio di tutte le culture alimentari che questa terra racchiude in sé, 
            in cui protagonisti assoluti sono frutta secca, miele, mosto cotto, oltre alle straordinarie essenze di bergamotto, cedri, mandarini, limoni...
            <br>
            <br>
            Un itinerario particolarmente godibile è quello che riguarda i vini calabresi, una tradizione antica che risale ai tempi degli Enotri e 
            che oggi vede la presenza di nove doc ottenute da una varietà di vitigni in cui primeggia il gaglioppo: le cantine storiche che si trovano un po’
             in tutta la Calabria, da Saracena alla Valle dell’Esaro, da Cosenza a Lamezia a Crotone, passando da Cirò, per finire a Bivongi, offrono godibilissimi 
             itinerari di degustazione sia lungo le coste che nelle aree interne.
            <br>
            <br>
            Per scoprire le tradizioni più autentiche della Calabria si può partecipare alle principali feste che animano borghi e paesi nel corso dell’anno, 
            appuntamenti legati non solo a ricorrenze religiose ma anche a specifiche iniziative legate al mondo contadino e alla produzione agroalimentare, 
            come ad esempio i riti arborei o le sagre che esaltano gli straordinari prodotti calabresi: peperoncino, cipolla, patate, ‘nduja, alici, stocco, castagne, 
            funghi, fagioli, fileja, caciocavalli, pane, vino, olio, ecc.... Un’altra straordinaria occasione per conoscere le tradizioni calabresi è 
            quella offerta dalle Vallje, danze popolari arbëreshe in costume tradizionale che si svolgono la domenica di Pasqua, il lunedì e il martedì successivi 
            principalmente a Civita, Frascineto, San Basile e Firmo.
            <br>
            <br>
            Oppure si può entrare in contatto con la cultura grecanica visitando Bova la Domenica delle Palme, in occasione della suggestiva processione delle Persephoni di Bova,
             Pupazze che rievocano la mitologia greca e la leggenda di Persefone discesa agli inferi, mito della rinascita “assimilato” alla Pasqua cristiana.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>